module.exports = __webpack_public_path__ + "img/mingbai3_5d06e58ff.png";